
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/business",
      function () {
        return require("private-next-pages/[locale]/business/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/business"])
      });
    }
  